<template>
  <div id="HomePage">
    <!-- 轮播图 -->
    <div id="swiper" class="container-fuild wow fadeIn">
      <div class="swiper-container banner-swiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in swiperList"
            :key="index"
          >
            <img class="swiper-lazy" :data-src="item.img" alt="轮播图" />
            <div class="swiper-lazy-preloader"></div>
            <div class="swiper-slide-title">
              <h1>{{ item.title }}</h1>
              <p>{{ item.content }}</p>
            </div>
          </div>
        </div>
        <!-- 如果需要分页器 -->
        <!-- <div class="swiper-pagination"></div> -->

        <!-- 如果需要导航按钮 -->
        <!-- <div class="swiper-button-prev"></div> -->
        <!-- <div class="swiper-button-next"></div> -->
      </div>
    </div>
    <!-- 为什么选择我们 -->
    <div id="whyChooseUs" class="conatiner-fuild">
      <div class="container">
        <!-- <h4 style="text-align: center; font-weight: bold">i换电加盟问卷</h4> -->
        <div class="illustrate">
          <p>问卷说明：</p>
          <p>
            1.了解热爱新能源行业，看好换电赛道的您。在资源匹配的基础下开展长期共赢的战略加盟合作。
          </p>
          <!-- <p>2.本次问卷共10个问题。</p> -->
          <p>3.问卷信息加密处理，保障信息安全</p>
        </div>
        <!-- <h4
          style="
            color: rgb(230, 81, 0);
            font-size: 16px;
            font-weight: 550;
            margin: 40px 0;
          "
        >
          第一部分 谈谈您和换电的故事
        </h4> -->
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="280px"
          class="demo-ruleForm"
          label-position="top"
        >
          <!--  -->
          <!-- <el-form-item
            label="1、您深耕换电行业多久了： 【单选题】"
            prop="深耕换电行业多久"
          >
            <el-radio-group v-model="ruleForm.深耕换电行业多久">
              <el-radio label="A半年"></el-radio><br />
              <el-radio label="B一年"></el-radio><br />
              <el-radio label="C两年"></el-radio><br />
              <el-radio label="D三年及以上"></el-radio>
            </el-radio-group>
          </el-form-item> -->
          <!--  -->
          <el-form-item label="2、您的姓名：" prop="姓名">
            <el-input v-model="ruleForm.姓名" placeholder="请输入"></el-input>
          </el-form-item>
          <!--  -->
          <el-form-item label="3、您的电话： " prop="电话">
            <el-input v-model="ruleForm.电话" placeholder="请输入"></el-input>
          </el-form-item>

         
          <el-form-item style="text-align: center">
            <el-button
              type="primary"
              class="subbut"
              @click="submitForm('ruleForm')"
              >提交加盟信息</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import { WOW } from "wowjs";
import { Dialog } from "vant";
import Vue from "vue";
import { buryingPoint } from "@/utils/utils.js";
import { addQuestionnaire } from "@/api/api";
Vue.use(Dialog);
export default {
  name: "HomePage",
  data() {
    return {
      swiperList: [
        {
          img: "https://static.wenjuan.pub/%E5%BC%80%E4%BC%9A1667291602746.png",
        },
      ],
      ruleForm: {
        '深耕换电行业多久':'',
        '姓名':'',
        '电话':'',
        '意向合作城市':'',
        '在当地是否有运营团队':'',
        '是否有企业经营经验':'',
        '是否有相关资源':'',
        '对当地骑手规模预估':'',
        '如何了解到i换电':'',
        '当地场地预计收费价位':'',
      },
      rules: {

        姓名: [{ required: true, message: "请输入内容", trigger: "blur" }],
        电话: [{ required: true, message: "请输入内容", trigger: "blur" }]
      },
      showImg: true,
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        buryingPoint('点击问卷数据提交','点击事件')
        this.$route.path
        if (valid) {
          let regu = /^1[3-9][0-9]{9}$/
          if(!regu.test(this.ruleForm.电话)){
            Dialog.alert({
                title: "提示",
                message: "请输入正确的手机号",
              }).then(() => {

              });
              return
          }
          addQuestionnaire({
            groupCode:this.$route.path == '/questionnaire'?"YNSITE":'WXIMM',
            questionnaireMap: this.ruleForm,
          }).then((res) => {
            if (res.data.code == 0) {
              Dialog.alert({
                title: "提示",
                message: "信息已提交,请等待客服回访",
              }).then(() => {
                buryingPoint('问卷数据提交成功','点击事件')
                this.$refs[formName].resetFields();
              });             
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  mounted() {
    buryingPoint('触达问卷调查页面')
    /* banner-swiper */
    new Swiper(".banner-swiper", {
      loop: false, // 循环模式选项
      effect: "fade",
      //自动播放
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      // 延迟加载
      lazy: {
        loadPrevNext: true,
      },
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, //修改swiper的父元素时，自动初始化swiper
    });
    /* customer-swiper */
    new Swiper(".customer-swiper", {
      loop: true, // 循环模式选项
      slidesPerView: 3,
      //自动播放
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, //修改swiper的父元素时，自动初始化swiper
    });
    /* wowjs动画 */
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true,
    });
    wow.init();
  },
};
</script>
<style scoped>
/* 整体盒子 */
#HomePage {
  width: 100%;
}

/* 轮播图 */
#swiper {
  height: 900px;
}
#swiper .banner-swiper {
  width: 100%;
  height: 100%;
}
#swiper .banner-swiper .swiper-slide img {
  width: 100%;
  height: 100%;
}
#swiper .banner-swiper .swiper-slide {
  position: relative;
}
#swiper .banner-swiper .swiper-slide-title {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999999;
  width: 100%;
  height: 100%;
  color: #fff;
  /* background: rgba(51, 51, 51, 0.534); */
  text-align: center;
  line-height: 80px;
}
#swiper .banner-swiper .swiper-slide-title > h1 {
  font-size: 50px;
  margin-top: 12%;
}
#swiper .banner-swiper .swiper-slide-title > p {
  font-size: 20px;
  margin-top: 1%;
  font-weight: 700;
}

/* 分隔条 */
.mars {
  height: 15px;
  background: #efefef;
}

/* 为什么选择我们 */
#whyChooseUs {
  padding: 50px 100px;
  /* background: #f4f4f4; */
}

.illustrate p {
  color: #666;
  display: block;
  font-size: 14px;
}
.illustrate p:nth-child(1) {
  font-weight: 550;
}
.el-input__inner {
  background-color: rgba(241, 243, 246, 0.5);
}

.subbut {
  width: 300px;
  height: 48px;
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  #swiper {
    height: 200px;
  }
  #whyChooseUs {
    padding: 20px 0;
    transition: all ease 0.6s;
  }
  .subbut {
    width: 100%;
    height: 48px;
  }
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
  #swiper {
    height: 400px;
  }
  #whyChooseUs {
    padding: 20px 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/view/questionnaires.vue